/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/validating.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    validatingModule
} from "../../../grids/grid_core/validating/m_validating";
import gridCore from "../m_core";
gridCore.registerModule("validating", validatingModule);
